import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import Team from "./pages/team/page";
import Description from "./pages/description/page";
import Engineering from "./pages/engineering/page";
import Safety from "./pages/safety/page";
import HumanPractices from "./pages/human-practices/page";
import Attributions from "./pages/attributions/page";
import Notebook from "./pages/notebook/page";
import Awards from "./pages/awards/page";
import ErrorPage from "./pages/error-page";
import Implementation from "./pages/implementation/page"
import WrapperLayout from "./contents/WrapperLayout";
import Measurement from "./pages/measurement/page";
import Modeling from "./pages/modeling/page";
import Education from "./pages/public-engagement/education";
import Entrepreneurship from "./pages/entrepreneurship/page";

import Parts from "./pages/parts/page";

import Protocols from "./pages/protrocols/page";

import Contribution from "./pages/contribution/page";


const routes = createBrowserRouter(
  [
    {
      path: "/",
      element: <WrapperLayout />, // Mantendo o layout principal
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <App />, // Página inicial
        },
        {
          path: "/team",
          element: <Team />,
        },
        {
          path: "/members",
          element: <Team />,
        },
        {
          path: "/contribution",
          element: <Contribution />,
        },
        {
          path: "/attributions",
          element: <Attributions />,
        },
        {
          path: "/entrepreneurship",
          element: <Entrepreneurship />,
        },
        {
          path: "/team",
          element: <Team />,
        },
        {
          path: "/measurement",
          element: <Measurement />,
        },
        {
          path: "/description",
          element: <Description />, // Subrota apontando para "ProjectDescription"
        },{path:"/notebook",
          element:<Notebook/>
        },{path:"/implementation",
          element:<Implementation/>
        },
        {
          path: "/education",
          element: <Education />,
        },
        {
          path: "/engineering",
          element: <Engineering />,
        },
        { path: "/modeling", element: <Modeling /> },
        {
          path: "/experiments",
          element: <Safety />,
        },
        {
          path: "/human-practices",
          element: <HumanPractices />,
        },
        {
          path: "/awards",
          element: <Awards />,
        },
        {
          path: "/safety",
          element: <Safety />,
        },
        
        {
          path: "/parts",
          element: <Parts />,
        },
        {
          path:"/protocols",
          element:<Protocols/>
        }
      ],
    },
  ],
  {
    basename: process.env.PUBLIC_URL, // Base URL definida, se necessário
  }
);

export default routes;
